// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILimitedUsePeriodDto
 */
export interface ILimitedUsePeriodDto {
    /**
     * 
     * @type {Date}
     * @memberof ILimitedUsePeriodDto
     */
    limited_period_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ILimitedUsePeriodDto
     */
    limited_period_end?: Date;
}

/**
 * Check if a given object implements the ILimitedUsePeriodDto interface.
 */
export function instanceOfILimitedUsePeriodDto(value: object): value is ILimitedUsePeriodDto {
    return true;
}

export function ILimitedUsePeriodDtoFromJSON(json: any): ILimitedUsePeriodDto {
    return ILimitedUsePeriodDtoFromJSONTyped(json, false);
}

export function ILimitedUsePeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILimitedUsePeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'limited_period_start': json['limited_period_start'] == null ? undefined : (new Date(json['limited_period_start'])),
        'limited_period_end': json['limited_period_end'] == null ? undefined : (new Date(json['limited_period_end'])),
    };
}

export function ILimitedUsePeriodDtoToJSON(json: any): ILimitedUsePeriodDto {
    return ILimitedUsePeriodDtoToJSONTyped(json, false);
}

export function ILimitedUsePeriodDtoToJSONTyped(value?: ILimitedUsePeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limited_period_start': value['limited_period_start'] == null ? undefined : ((value['limited_period_start']).toISOString().substring(0,10)),
        'limited_period_end': value['limited_period_end'] == null ? undefined : ((value['limited_period_end']).toISOString().substring(0,10)),
    };
}

